module.exports = __webpack_public_path__ + "img/dot.be349558.svg";